import styled from '@emotion/styled';
import { Tab } from '@mui/material';
import TabList from '@mui/lab/TabList';
import { TabPanel } from '@mui/lab';

export const StyledTab = styled(Tab)(
  () => `
  color: #000;
  text-transform: none;
  padding-left: 0;
  padding-right: 0;
  min-width: 0;
  margin-right: 16px;
`,
);

export const StyledTabList = styled(TabList)(
  () => `
  .MuiTabs-indicator {
    bottom: 10px;
  }
`,
);

export const StyledTabPanel = styled(TabPanel)(
  () => `
  padding: 0
`,
);
